module.exports = __webpack_public_path__ + "operace-nosu_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_7_after.jpg
// module id = 1139
// module chunks = 0